export default from './CookieConsent';



// WEBPACK FOOTER //
// ./src/components/organismes/CookieConsent/index.js